import { useEffect, useState } from "react";
import { captureError } from "@/lib/sentry";
import AppLayout from "@/components/AppLayout";
import GameCard from "@/components/GameCard";
import { api } from "@/lib/api";

export default function LiveCompanion() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/games")
      .then((r) => setGames((r.data || []).filter((g) => g.status === "LIVE")))
      .catch((err) => captureError("live companion load failed:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AppLayout>
      <div className="mb-6 fade-up">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF453A] mb-2 inline-flex items-center gap-1.5">
          <span className="live-dot" /> Live Companion
        </p>
        <h1 className="font-display font-bold text-4xl md:text-5xl uppercase tracking-tighter">Live Right Now</h1>
        <p className="text-white/60 text-sm mt-2">Every live game with scores, win probability, and instant AI breakdowns.</p>
      </div>
      {loading ? (
        <div className="text-white/60 text-sm">Loading live games…</div>
      ) : games.length === 0 ? (
        <div className="p-10 rounded-md bg-[#121212] border border-white/10 text-center">
          <p className="font-display font-bold text-lg uppercase tracking-tight mb-2">Nothing live right now</p>
          <p className="text-white/55 text-sm">Check Today's Games for upcoming and final scores.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {games.map((g) => (
            <GameCard key={g.id} game={g} />
          ))}
        </div>
      )}
    </AppLayout>
  );
}
